import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login";
import MainMenu from "./views/MainMenu";
import ManageUser from "./views/Settings/ManageUser";
import ManageRole from "./views/Settings/ManageRole";
import MeetingRoomScreen from "./views/MeetingRoomScreen";
import Facility from "./views/Infrastructure/Facility";
import Location from "./views/Infrastructure/Location";
import Utility from "./views/Infrastructure/Utility";
import Zone from "./views/Infrastructure/Zone";
import TransactionRoomBooking from "./views/TransactionRoomBooking";
import CheckinMeeting from "./views/CheckinMeeting";
import Roompad from "./views/Roompad";
import ReservationCondition from "./views/ReservationCondition";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: {
        name: "Login",
      },
    },
    {
      path: "/Login",
      name: "Login",
      component: Login,
    },
    {
      path: "/MainMenu",
      name: "MainMenu",
      component: MainMenu,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ManageUser",
      name: "ManageUser",
      component: ManageUser,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ManageRole",
      name: "ManageRole",
      component: ManageRole,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/MeetingRoomScreen",
      name: "MeetingRoomScreen",
      component: MeetingRoomScreen,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Facility",
      name: "Facility",
      component: Facility,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Location",
      name: "Location",
      component: Location,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Utility",
      name: "Utility",
      component: Utility,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Zone",
      name: "Zone",
      component: Zone,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/TransactionRoomBooking",
      name: "TransactionRoomBooking",
      component: TransactionRoomBooking,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Roompad",
      name: "Roompad",
      component: Roompad,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ReservationCondition",
      name: "ReservationCondition",
      component: ReservationCondition,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/CheckinMeeting:id",
      name: "CheckinMeeting",
      component: CheckinMeeting,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

let isRedirecting = false;

router.beforeEach((to, from, next) => {
  if (isRedirecting) return;

  const token = Vue.$cookies.get("Token") || localStorage.getItem("Token");
  const isLoggedIn =
    Vue.$cookies.get("isLoggedIn") === true ||
    Vue.$cookies.get("isLoggedIn") === "true" ||
    localStorage.getItem("isLoggedIn") === "true";

  if (to.matched.some((r) => r.meta.requiresAuth)) {
    if (!token || !isLoggedIn) {
      isRedirecting = true;
      next("/Login");
      setTimeout(() => (isRedirecting = false), 1000);
      return;
    }
  }
  const roleID = Vue.$cookies.get("roleID") || localStorage.getItem("roleID");
  if (to.name === "Login" && token && isLoggedIn) {
    if (roleID == 3) {
      return next("/MeetingRoomScreen");
    }
    return next("/MainMenu");
  }

  next();
});

export default router;
